import createPersistedState from 'vuex-persistedstate';
import global from '@/store/modules/global';
const paths = [...Object.keys(global.state), 'global'];
/**
 * 设置vuex插件
 */
export function setPlugins() {
  const plugins = [];
  plugins.push(
    createPersistedState({
      key: 'app-assess',
      storage: window.sessionStorage,
      reducer: state => {
        const info = Object.assign({}, state);
        paths.forEach(key => delete info[key]);
        return info;
      }
    })
  );
  plugins.push(
    createPersistedState({
      // store持久化本地的key值，这是全局模块的每个项目都需要有，名称是固定的
      key: 'yeemiao-global',
      reducer: state => {
        return state.global;
      },
      storage: window.sessionStorage
    })
  );
  return plugins;
}



// WEBPACK FOOTER //
// ./src/store/plugins.js